(function () {
  // Galería de producto
  document.querySelectorAll('.gallery').forEach(function (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      showMedia(gallery, thumb.getAttribute('data-thumb'));
    });
  });

  function showMedia(gallery, id) {
    if (!gallery || !id) return;
    var slide = gallery.querySelector('[data-media-id="' + id + '"]');
    if (!slide) return;
    gallery.querySelectorAll('.gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
  }

  // Cantidad
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10));
    input.value = next;
  });

  // Formato de precio según la moneda de la tienda
  function formatMoney(cents, format) {
    cents = Math.round(cents);
    function fmt(n, dec, thousands, decimal) {
      var parts = (n / 100).toFixed(dec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return (format || '${{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }

  // Packs por cantidad
  function updateBundles(section, unitCents, unitCompare) {
    var box = section.querySelector('[data-bundles]');
    if (!box) return;
    var fmt = section.getAttribute('data-money-format');
    var transferPct = parseInt(section.getAttribute('data-transfer-pct'), 10) || 0;
    var qtyInput = section.querySelector('[data-qty-input]');
    var selectedTotal = unitCents;
    box.querySelectorAll('.bundle__input').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 1;
      var pct = parseInt(input.getAttribute('data-pct'), 10) || 0;
      var packCents = parseInt(input.getAttribute('data-pack-cents'), 10) || 0;
      var full = unitCents * qty;
      var total = packCents > 0 ? packCents : Math.floor(full * (100 - pct) / 100);
      var label = box.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.querySelector('[data-bundle-price]').textContent = formatMoney(total, fmt);
        label.querySelector('[data-bundle-compare]').textContent = total < full ? formatMoney(full, fmt) : '';
        var badge = label.querySelector('[data-bundle-badge]');
        if (badge && full > 0) badge.textContent = Math.round((full - total) * 100 / full) + '% OFF';
      }
      if (input.checked) {
        selectedTotal = total;
        if (qtyInput) qtyInput.value = qty;
        var priceEl = section.querySelector('[data-price]');
        var compareEl = section.querySelector('[data-compare]');
        if (priceEl) priceEl.textContent = formatMoney(total, fmt);
        if (compareEl) compareEl.textContent = qty > 1 ? (total < full ? formatMoney(full, fmt) : '') : (unitCompare || '');
      }
    });
    var transferEl = section.querySelector('[data-transfer]');
    if (transferEl && transferPct > 0) transferEl.textContent = formatMoney(Math.floor(selectedTotal * (100 - transferPct) / 100), fmt);
  }

  // Variantes
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var section = root.closest('[data-product-root]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var transferEl = section.querySelector('[data-transfer]');
    var gallery = section.querySelector('.gallery');
    var unitCents = (variants[idInput.value] || {}).cents || 0;
    var unitCompare = (variants[idInput.value] || {}).compare || '';

    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('bundle__input')) {
        updateBundles(section, unitCents, unitCompare);
        return;
      }
      if (!e.target.closest('[data-option-index]')) return;
      var selected = Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
      var match = null;
      Object.keys(variants).some(function (id) {
        var v = variants[id];
        if (v.options.every(function (o, i) { return o === selected[i]; })) { match = { id: id, v: v }; return true; }
        return false;
      });
      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = 'No disponible';
        return;
      }
      idInput.value = match.id;
      addBtn.disabled = !match.v.available;
      addBtn.textContent = match.v.available ? 'Agregar al carrito' : 'Sin stock';
      if (priceEl) priceEl.textContent = match.v.price;
      if (compareEl) compareEl.textContent = match.v.compare;
      if (transferEl) transferEl.textContent = match.v.transfer;
      unitCents = match.v.cents;
      unitCompare = match.v.compare;
      updateBundles(section, unitCents, unitCompare);
      if (match.v.media) showMedia(gallery, match.v.media);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  // Cerrar menú celular al tocar afuera
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('.menu-drawer[open]');
    if (drawer && !drawer.contains(e.target)) drawer.removeAttribute('open');
  });
})();
